module.exports = __webpack_public_path__ + "static/media/gq.d352f9e1.svg";